<div
     style="border-bottom: solid 1px #E6E9EC;"
     class="d-flex flex-row flex-nowrap align-items-center px-3 py-3">
  <img style="height: 45px;"
       class="d-inline-block mr-5 align-middle"
       [src]="'assets/images/brand-primary.svg?v=' + system.getVersion()"
       i18n-alt="@@global.title"
       alt="Cebreo Portal" />

  <button class="navbar-toggler p-0 ml-auto border-0"
          mat-icon-button
          type="button"
          *ngIf="!(layoutService.getSideNavState() | async)"
          (click)="layoutService.collapseSideNav()">
    <mat-icon fontSet="design">menu_open</mat-icon>
  </button>
</div>

<div class="flex-fill pt-3 overflow-x-hidden overflow-y-auto">
  <ng-container *ngFor="let item of menu">
    <mat-expansion-panel *hasAnyAuthority="item.authorities" expanded="true">
      <mat-expansion-panel-header collapsedHeight="52px" expandedHeight="52px">
        <mat-panel-title>
          <a
             class="nav-link px-0 text-nowrap"
             [href]="item.link"
             [class.active]="router.isActive(item.link, false)"
             (click)="$event.preventDefault()">
            <mat-icon class="mr-2 align-middle" [fontSet]="item.iconFont">{{item.iconName}}</mat-icon>{{item.label}}
          </a>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <nav class="nav flex-column">
        <ng-container *ngFor="let child of item.children">
          <ng-container
                        *ngIf="!child.deps || (child.deps?.includes('apiDocsEnabled') && profileInfo?.apiDocsEnabled)">
            <a class="nav-link text-nowrap"
               *hasAnyAuthority="child.authorities"
               [routerLink]="child.link"
               routerLinkActive="active">
              {{child.label}}
            </a>
          </ng-container>
        </ng-container>
      </nav>
    </mat-expansion-panel>
  </ng-container>
</div>